import styled from 'styled-components'

import { useNavigate } from '../../hooks/useNavigate'

import { Text } from '../text'
import { LeftButtonBox } from './Header'
import type { HeaderContentProps } from './Header'

import { ReactComponent as BackBlack } from '../../assets/ico/common/arrow/left/arrow_left_black_large.svg'
import { ReactComponent as BackWhite } from '../../assets/ico/common/arrow/left/arrow_left_white_large.svg'

export function Sub({
  title,
  href,
  rightItem,
  isScrollEvent,
  isScrolling,
  onBack,
  isBack = true,
  isRoute = true,
}: HeaderContentProps) {
  const navigate = useNavigate()

  const back = () => {
    onBack?.()

    if (isRoute) {
      href ? navigate(href) : navigate(-1)
    }
  }

  return (
    <>
      {(isBack || title) && (
        <TitleBox>
          {isBack && (
            <LeftButtonBox onClick={back}>
              {isScrollEvent && !isScrolling ? <BackWhite /> : <BackBlack />}
            </LeftButtonBox>
          )}
          {title && (
            <Text
              size={20}
              weight={600}
              color={typeof isScrolling === 'undefined' ? 'text_primary' : isScrolling ? 'text_primary' : 'white'}
            >
              {title}
            </Text>
          )}
        </TitleBox>
      )}
      {rightItem && <>{rightItem}</>}
    </>
  )
}

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
`
